import { render, staticRenderFns } from "./AppleRelayEmailNotice.vue?vue&type=template&id=3e68cb4a&scoped=true"
import script from "./AppleRelayEmailNotice.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppleRelayEmailNotice.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./AppleRelayEmailNotice.vue?vue&type=style&index=0&id=3e68cb4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e68cb4a",
  null
  
)

export default component.exports